"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCartPromoCartPrice = exports.mockCartPromoCartContains = exports.mockCartPromoPrices = exports.isCartPromoCartPrice = exports.isCartPromoCartContains = void 0;
const product_family_1 = require("./product_family");
const subcategory_1 = require("./subcategory");
function isCartPromoCartContains(cartPromo) {
    return cartPromo.quantity != null;
}
exports.isCartPromoCartContains = isCartPromoCartContains;
function isCartPromoCartPrice(cartPromo) {
    return cartPromo.quantity == null;
}
exports.isCartPromoCartPrice = isCartPromoCartPrice;
function mockCartPromoPrices(overrides = {}) {
    return {
        cart_price: 50.0,
        item_price: 5.0,
        ...overrides,
    };
}
exports.mockCartPromoPrices = mockCartPromoPrices;
function mockCartPromoCartContains(overrides = {}) {
    return {
        cart_contains_array: [
            {
                cart_contains_item: (0, subcategory_1.mockSubcategory)(),
                cart_contains_type: 'Subcategory',
            },
        ],
        cart_contains_type: null,
        cart_contains: null,
        discount_percent: 10,
        hide_from_cart: false,
        message: 'mock cart promo',
        premium_only: false,
        product_family: (0, product_family_1.mockProductFamily)(),
        quantity: 1,
        ...overrides,
        cart_promos: [],
    };
}
exports.mockCartPromoCartContains = mockCartPromoCartContains;
function mockCartPromoCartPrice(overrides = {}) {
    return {
        cart_contains_type: null,
        cart_promos: [mockCartPromoPrices()],
        cart_contains: null,
        hide_from_cart: false,
        message: 'mock cart promo',
        premium_only: false,
        product_family: (0, product_family_1.mockProductFamily)(),
        ...overrides,
        quantity: null,
        discount_percent: null,
        cart_contains_array: [],
    };
}
exports.mockCartPromoCartPrice = mockCartPromoCartPrice;
